<ng-container>
	<div class="px-5 py-8 min-w-[250px] max-w-[95vw] sm:max-w-[500px] relative rounded bg-white shadow-lg">
		<div (click)="onClose()" class="absolute top-1 right-2">
			<span class="material-symbols-outlined cursor-pointer">
				close
			</span>
		</div>
		<div *ngIf="selectedStep === 1"
			 class="fb-order-feedback-rate">
			<h1 class="text-base md:text-xl p-1 font-medium">We are delighted to have you as a part of Anuprerna. We appreciate your feedback.</h1>
			<h3 class="text-sm text-[#9fa6b8] p-2 ">Please Rate Your Experience With Us</h3>
			<div class="fb-of-rate my-3">
				<div class="fb-of-ratings flex justify-between items-center gap-0.5">
					<div *ngFor="let rate of ratings"
						 [ngClass]="[rate <= 6? 'fb-rate-red': rate <=8? 'fb-rate-yellow':'fb-rate-green',
						 feedback.question1Answer === rate? 'selected': '']"
						 (click)="selectRating(rate)"
						 class="py-1 px-2 sm:py-2 sm:px-3.5 text-sm md:text-base flex justify-center items-center rounded md:rounded-xl cursor-pointer">
						{{rate}}
					</div>
				</div>
				<div class="w-full flex justify-between items-center py-1 text-[#9fa6b8] text-xs">
					<p>Least satisfied</p>
					<p>Most satisfied</p>
				</div>
			</div>
		</div>
		<div *ngIf="selectedStep === 2" class="fb-order-feedback-opinion">
			<h1 class="text-base md:text-xl p-1 font-medium flex items-center">
				<span (click)="selectedStep = 1" class="material-symbols-outlined cursor-pointer">
					arrow_back_ios
				</span>
				Did you find what you were looking for?
			</h1>
			<div class="fb-of-yes-no flex justify-between items-center gap-0.5 my-5">
				<div [ngClass]="feedback.question2 && feedback.question2Answer? 'selected':''"
					 (click)="selectFind(true)"
					 class="py-2.5 w-full cursor-pointer bg-gray-50 border border-gray-200 flex justify-center items-center rounded-md">Yes</div>
				<div [ngClass]="feedback.question2 && !feedback.question2Answer? 'selected':''"
					 (click)="selectFind(false)"
					 class="py-2.5 w-full cursor-pointer bg-gray-50 border border-gray-200 flex justify-center items-center rounded-md">No</div>
			</div>
			<div *ngIf="feedback.question2 && !feedback.question2Answer">
				<h1 class="text-sm md:text-lg p-1 font-medium">Tell us more about the items you were looking more</h1>
				<textarea class="p-2.5 w-full bg-gray-100 border border-gray-200 rounded-md mt-2"
						  [formControl]="negativeAnswer"
						  rows="3"
						  placeholder="Type your answer here..."></textarea>
				<div *ngIf="negativeAnswer.dirty && negativeAnswer.invalid" class="text-red-500 text-xs mb-2">this input is required</div>
				<div class="fb-of-yes-no flex justify-end items-center gap-0.5 my-1">
					<button (click)="submitNegativeAnswer()"
							class="py-1.5 px-5 w-min bg-gray-100 hover:bg-[#8E7862] flex justify-center items-center rounded-md">Submit</button>
				</div>
			</div>
		</div>
		<div *ngIf="selectedStep === 3" class="fb-order-feedback-more my-2">
			<h1 class="text-base md:text-xl p-1 font-medium flex items-center">
				<span (click)="selectedStep = 2"
					  class="material-symbols-outlined cursor-pointer">
					arrow_back_ios
				</span>
				Is there anything else you would like to share with us to help serve you better?
			</h1>
			<textarea [formControl]="moreFeedback"
					  class="p-2.5 w-full bg-gray-100 border border-gray-200 rounded-md mt-2" rows="4" placeholder="Type your answer here..."></textarea>
			<div *ngIf="moreFeedback.dirty && moreFeedback.invalid" class="text-red-500 text-xs mb-2">this input is required</div>
			<div class="fb-of-yes-no flex justify-end items-center gap-0.5 my-1">
				<button (click)="submitMoreFeedback()"
						class="py-1.5 px-5 w-min bg-gray-100 hover:bg-[#8E7862] flex justify-center items-center rounded-md">Submit</button>
			</div>
		</div>
		<div *ngIf="selectedStep === 4" class="fb-order-feedback-thanks text-center py-3">
			<h1 class="text-xl p-1 font-medium">Thank you for your valuable feeback</h1>
			<h3 class="text-sm text-[#9fa6b8] p-2 ">Hope to serve you better</h3>
		</div>
		<div *ngIf="selectedStep !== 4" class="fb-of-sections flex justify-center items-center gap-0.5">
			<div [ngClass]="selectedStep === 1? 'selected-step': ''" class="bg-gray-100 w-[50px] h-[3px]"></div>
			<div [ngClass]="selectedStep === 2? 'selected-step': ''" class="bg-gray-100 w-[50px] h-[3px]"></div>
			<div [ngClass]="selectedStep === 3? 'selected-step': ''" class="bg-gray-100 w-[50px] h-[3px]"></div>
		</div>
	</div>
</ng-container>
